import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('fcfwdCkuSttsStore', Object.keys(getters)),
	...mapState('fcfwdCkuSttsStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('fcfwdCkuSttsStore', Object.keys(actions)),
	...mapMutations('fcfwdCkuSttsStore', Object.keys(mutations))
};
